import React, { useEffect, useRef } from 'react'
import styled from '@emotion/styled'
import TrackVisibility from 'react-on-screen'
import { bool, node } from 'prop-types'

import { smoothScrollIntoView } from '@jelly/utils'

const BaseErrorList = styled.ul`
	padding: 8px;
	display: table;
	margin: 0 auto;

	${({ theme }) => theme.MQ.M} {
		width: 70%;
	}
`

const ErrorTrack = ({ isVisible, children }) => {
	const errorRef = useRef(null)

	useEffect(() => {
		if (!isVisible) {
			smoothScrollIntoView(errorRef.current)
		}
	}, [isVisible])

	return <BaseErrorList ref={errorRef}>{children}</BaseErrorList>
}

ErrorTrack.propTypes = {
	isVisible: bool,
	children: node.isRequired,
}

ErrorList.propTypes = {
	children: node.isRequired,
}

export function ErrorList({ children }) {
	return (
		<TrackVisibility>
			<ErrorTrack>{children}</ErrorTrack>
		</TrackVisibility>
	)
}
